<header>
    
    <div class="left-header-logo left-header-logo-sm" role="img"  aria-hidden="true">
    </div>
    <div class="right-header-logo" role="img"  aria-hidden="true">
    </div>

</header>
